import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuthHandling } from "./baseQuery";

export const staticApi = createApi({
  reducerPath: "staticApi",
  baseQuery: baseQueryWithAuthHandling,
  tagTypes: [],
  endpoints: (builder) => ({
    getAllStaticRoutes: builder.query({
      query: () => ({
        url: "/staticdata/getAllStaticRoutes",
        method: "GET",
      }),
    }),
  }),
});

export const {
  useGetAllStaticRoutesQuery,
} = staticApi;
